import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bffApiClient } from '@api/bff/client';
import { apiKeyKeys } from '../constants';
import type { GeneratedApiKeyViewModel } from '../types';

export const useGenerateApiKey = () => {
  const queryClient = useQueryClient();

  return useMutation<GeneratedApiKeyViewModel, Error>({
    mutationFn: async () => {
      const response = await bffApiClient.post<GeneratedApiKeyViewModel>(
        '/api/api-keys/generate'
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: apiKeyKeys.me });
    }
  });
};
